<!-- Large banner with separate person -->
<template>
  <Fragment>
    <div class="blue_bg" />
    <div class="info" :class="extraClass">
      <h3 :class="{ onlyH3: !subTitle }">
        <span v-html="title"></span>
      </h3>
      <h4>{{ subTitle }}</h4>
      <div class="banner_button" v-if="buttonLink">
        <el-button class="white_button" @click.native.stop="onButtonClick">
          {{ buttonText }}
        </el-button>
      </div>
    </div>
    <div v-if="rightSideImg" class="r-side-img">
      <img :src="rightSideImg" alt />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
  name: 'BannerItem',
  props: ['extraClass', 'title', 'subTitle', 'buttonLink', 'buttonText', 'rightSideImg'],
  components: {
    Fragment
  },
  data() {
    return {};
  },
  methods: {
    onButtonClick() {
      window.open(this.buttonLink);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './bannerItem.scss';
</style>
